/**
 *
 * Helmet
 *
 */

import React, { memo } from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

function Helmet(props) {
  const { title, content, children } = props;
  return (
    <ReactHelmet>
      {title && <title>{title}</title>}
      {content && (
        <meta data-react-helmet="true" name="description" content={content} />
      )}
      {children}
    </ReactHelmet>
  );
}

Helmet.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.string,
};

export default memo(Helmet);
